

import {
    t,
    Trans
} from "@lingui/macro"
import { Button, Chip, Typography } from "@mui/material"
import { GridColDef } from "@mui/x-data-grid"


const defaultColumnDefinition: GridColDef = {
    field: "",
    headerName: "",
    headerAlign: "left",
    align: "left",
}

const getMicrojobStatus = (params: string): any => {
    switch (params) {
        case "CREATED":
            return {
                label: t({ id: "mj-created", message: "Disponibile" }),
                color: 'info',
                sx: {
                    "& .MuiChip-label": {
                        color: "background.default"
                    },
                    borderRadius: 5
                }
            }
        case "ASSIGNED":
            return {
                label: t({ id: "mj-assigned", message: "Assegnato" }),
                color: 'secondary',
                sx: {
                    "& .MuiChip-label": {
                        color: "background.default"
                    },
                    borderRadius: 5
                }
            }
        case "IN_REVIEW":
            return {
                label: t({ id: "mj-in-review", message: "In Revisione" }),
                color: 'warning',
                sx: {
                    "& .MuiChip-label": {
                        color: "background.default"
                    },
                    borderRadius: 5
                }
            }
        case "COMPLETED":
            return {
                label: t({ id: "mj-concluded", message: "Concluso" }),
                color: 'success',
                sx: {
                    "& .MuiChip-label": {
                        color: "background.default"
                    },
                    borderRadius: 5
                }
            }
    }
}

export interface MicrojobJobsTableInterface {
    openModal: (row: any) => void
}

const getMicrojobJobsTableColumns = (component: MicrojobJobsTableInterface, isAdmin: boolean = false): GridColDef[] => {
    return [
        // {
        //     ...defaultColumnDefinition,
        //     field: "id",
        //     headerName: t({
        //         id: "mjj-id",
        //         message: "ID Proposta",
        //     }),
        //     flex: 4,
        //     sortable: false
        // },
        {
            ...defaultColumnDefinition,
            field: "title",
            headerName: t({
                id: "mjj-title",
                message: "Titolo",
            }),
            sortable: false,
            flex: 7
        },
        {
            ...defaultColumnDefinition,
            field: "status",
            headerName: t({
                id: "mjj-status",
                message: "Stato"
            }),
            flex: 3,
            sortable: false,
            renderCell: (params: any) => {
                return <Chip {...getMicrojobStatus(params.row.status)} />
            }
        },
        {
            ...defaultColumnDefinition,
            field: "button",
            flex: 2,
            sortable: false,
            renderCell: (params: { row: any }) => (
                <Button
                    variant="contained"
                    size="small"
                    disableElevation
                    sx={{
                        textTransform: 'none',
                        backgroundColor: 'secondary.main',
                        color: 'white',
                    }}
                    onClick={() => (component.openModal(params.row))}
                >
                    <Typography>
                        <Trans id="mjtview-details">
                            Dettagli
                        </Trans>
                    </Typography>
                </Button>


            ),
        },
    ]
}

export default getMicrojobJobsTableColumns
